import { REGEX } from "consts";

const inputs = {
  firstname: {
    id: 'firstname',
    name: 'firstname',
    input: 'textField',
    label: 'userList.form.firstname.label',
    placeholder: 'userList.form.firstname.placeholder',
    rules: {
      required: { value: true },
    },
  },
  surname: {
    id: 'surname',
    name: 'surname',
    input: 'textField',
    label: 'userList.form.surname.label',
    placeholder: 'userList.form.surname.placeholder',
    rules: {
      required: { value: true },
    },
  },
  username: {
    id: 'username',
    name: 'username',
    input: 'textField',
    label: 'userList.form.username.label',
    placeholder: 'userList.form.username.placeholder',
    rules: {
      required: { value: true },
    },
  },
  email: {
    id: 'email',
    name: 'email',
    input: 'textField',
    label: 'userList.form.email.label',
    placeholder: 'userList.form.email.placeholder',
    rules: {
      required: { value: true },
      pattern: { value: REGEX.EMAIL, message: 'common.rules.email' }
    },
  },
  active: {
    id: 'active',
    name: 'active',
    input: 'checkbox',
    label: 'userList.form.active.label',    
  },
  admin: {
    id: 'admin',
    name: 'admin',
    input: 'checkbox',
    label: 'userList.form.admin.label',    
  },
  password: {
    id: 'password',
    name: 'password',
    input: 'textField',
    type: 'password',
    label: 'userList.form.password.label',
    placeholder: 'userList.form.password.placeholder',
    rules: {
      required: { value: true },
    },
  },
  confirmPassword: {
    id: 'confirmPassword',
    name: 'confirmPassword',
    input: 'textField',
    type: 'password',
    label: 'userList.form.confirmPassword.label',
    placeholder: 'userList.form.confirmPassword.placeholder',
    rules: {
      required: { value: true },
    },
  },
  role: {
    id: 'role',
    name: 'role',
    input: 'select',
    label: '',
    helpertext: 'userList.form.role.helperText',
  },
  permissions: {
    id: 'permissions',
    type: 'array',
    name: 'permissions',
  },
  roles: {
    id: 'roles',
    type: 'array',
    name: 'roles',
  }
}

export default inputs;